
<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Deleção de Região"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar esta região?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@components/shared/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
  },
  methods: {
    destroyServerEntry: function(region) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_REGION_MUTATION,
            variables: {
              id: region.id,
            }
          })
          .then(response => {
            var errors = response.data.destroyRegion.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
  }
}
const DESTROY_REGION_MUTATION = gql `
  mutation($id: ID!) {
    destroyRegion(id: $id) {
      region {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>

